import { axiosInstance } from '../../../../services/base';

export function getLeaveReportSummary(filter) {
    const headers = { Authorization: `Bearer ${localStorage.getItem('auth_token')}` };
    return axiosInstance.get('/admin/leaves/summary', {
        params: { filter: filter },
        headers,
    });
}

export function getUpcomingLeaves() {
    const headers = { Authorization: `Bearer ${localStorage.getItem('auth_token')}` };
    return axiosInstance.get('/admin/leaves/get-upcoming-leaves', {
        params: { filter: null },
        headers,
    });
}

export function getEmployeeLeaves(employeeId) {
    const headers = { Authorization: `Bearer ${localStorage.getItem('auth_token')}` };
    return axiosInstance.get(`/admin/leaves/get-employee-leaves/${employeeId}`, {
        params: {},
        headers,
    });
}

export function getAllEmployeeLeaves() {
    const headers = { Authorization: `Bearer ${localStorage.getItem('auth_token')}` };
    return axiosInstance.get('/admin/leaves/get-all-employee-leaves', {
        params: {},
        headers,
    });
}
